import { NavItemWithChildren } from '@app/components/layout/sidenav/link/NavItemWithChildren';
import { useDefaultStation } from '@app/core/stations/hooks/useDefaultStation';
import { useIntl } from 'react-intl';
import { FragmentIcon } from '../components/FragmentIcon';

export function useDefaultStationPath(pathWithStation: string) {
  const station = useDefaultStation();

  return pathWithStation.replace('{slug}', station.slug);
}

export function FragmentsLinks() {
  const { $t } = useIntl();

  return (
    <NavItemWithChildren
      root={useDefaultStationPath('/fragments')}
      label={$t({
        id: 'fragments.title',
        defaultMessage: 'Fragmentos',
      })}
      icon={<FragmentIcon />}
    />
  );
}
